<template>
  <b-container fluid>
    <div v-if="!elevatorsLoaded" class="d-flex justify-content-center align-items-center my-5">
      <b-spinner class="mr-2" /><span>Loading&hellip;</span>
    </div>
    <template v-else>
      <!--
    <b-row>
      <b-col>
        <h2>{{ this.nameForStatus(parseInt(showStatus)) }}</h2>
      </b-col>
    </b-row>
    -->
      <brands-filter :panel.sync="activePanel"
        :filter-active="(selBrands.length > 0 && selBrands.length < elevatorBrands.length) || (selTypes.length > 0 && selTypes.length < elevatorTypes.length)" :brands="elevatorBrands"
        :selected-brands.sync="selectedBrands" :model-types="elevatorTypes" :selected-model-types.sync="selectedTypes"
        :show="realElevatorTypes.length > 1 || selBrands.length > 0 || selTypes.length > 0" name-prefix="elevators" @invert="invert()" @all="onBrandsAll()">
        <template #buttons>
          <b-button size="sm" @click="activePanel = activePanel === 'columns' ? null : 'columns'"
            variant="primary">Columns</b-button>
        </template>
        <template #search>
          <clearable-input v-model="textFilter" placeholder="Filter..."></clearable-input>
        </template>
        <template #extra-panel>
          <div v-show="activePanel === 'columns'" class="filter-panel-content">
            <b-row>
              <b-col v-for="group in columnGroupDefs" :key="group.id">
                <draggable :list="groupItems[group.id]" handle=".drag-handle" group="columns" @end="syncColOrder">
                  <div v-for="col in groupItems[group.id]" :key="col.value" class="column-drag-item">
                    <span class="drag-handle">&#9776;</span>
                    <b-form-checkbox v-model="selectedColumns" :value="col.value">{{ col.text }}</b-form-checkbox>
                  </div>
                </draggable>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <b-button size="sm" variant="secondary" @click="resetColumns">Default</b-button>
              </b-col>
            </b-row>
          </div>
        </template>
      </brands-filter>

      <b-row>
        <b-col>
          <b-row>
            <b-col>
            </b-col>


          </b-row>

          <b-row class="mt-3">
            <b-col>
              <b-table id="elevators" striped :sort-compare.sync="sortCompare" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :items="filteredElevators" :fields="fields" @row-clicked="rowClickedHandler"
                :per-page="perPage" :current-page="currentPage" @sort-changed="onSortChanged">
                <template #cell(status)="data">
                  <svg height="18" width="18" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
                    <title>{{ nameForStatus(data.item.status) }}</title>
                    <circle :class="classForElevator(data.item)" cx="5" cy="5" r="5" />
                  </svg>
                </template>
                <template #cell(name)="{ item }">
                  <router-link :to="'/lifts/' + item.id" class="row-link">{{ elevatorName(item) }}</router-link>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row class="mt-2 align-items-center">
            <b-col cols="auto" v-if="filteredElevators.length > 15">
              <b-form-select v-model="perPage" :options="perPageOptions" style="width: auto"></b-form-select>
            </b-col>

            <b-col v-if="perPage != 0 && filteredElevators.length > 15">
              <b-pagination v-model="currentPage" :total-rows="filteredElevators.length" :per-page="perPage"
                aria-controls="elevators" class="mb-0"></b-pagination>
            </b-col>

            <b-col cols="auto" class="ml-auto">
              <b-button size="sm" @click.stop="modalReportOpen($event.target)">Report</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-modal id="modalReport" title="Report" ok-variant="primary" ok-title="Generate" @ok="getReport">
        <b-container>
          <b-row align-v="center">
            <b-col>
              <b-form v-if="!generatingReport">
                From: <date-picker :value="fromDate" @change="setFrom" input-style="width:150px;display:inline-block" />
                To: <date-picker :value="toDate" @change="setTo" input-style="width:150px;display:inline-block" />
              </b-form>
              <div v-else>
                Please wait...
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal>

    </template>
  </b-container>
</template>

<script>
import api from './api.js'
import auth from './auth.js'
import moment from 'moment';
import formatter from './formatter.mixin.js';
import DatePicker from './DatePicker.vue'
import ClearableInput from './ClearableInput.vue'
import BrandsFilter from './BrandsFilter.vue'
import { brandFilterStore, persistBrands, persistModelTypes } from './brandFilter.store.js'

import Draggable from 'vuedraggable';

const DEFAULT_COLUMNS = ['type', 'name', '_maintAvgPerDay'];

const COLUMN_GROUPS = [
  {
    id: 'general',
    label: null,
    keys: ['type', '_model', 'name', 'host', '_dropsToday', '_avgDropsPerDay'],
  },
  {
    id: 'location',
    label: 'Location',
    keys: ['addressLine1', 'zipCode', 'city', 'region', 'country'],
  },
  {
    id: 'details',
    label: 'Details',
    keys: ['cid', 'cdate', 'eqdescr', 'description', 'notes'],
  },
  {
    id: 'trips',
    label: 'Trips',
    keys: ['stopsToday', '_maintAvgPerDay', 'stopsUntilService', '_maintEstimate', '_maintScheduled'],
  },
];

export default {
  name: 'elevators',
  components: {
    'draggable': Draggable,
    DatePicker,
    ClearableInput,
    BrandsFilter,
  },
  props: [
    'elevators',
    'elevatorsLoaded',
  ],
  mixins: [formatter],
  data() {
    return {
      localTextFilter: (window.history.state && window.history.state.textFilter) || '',
      perPage: parseInt(localStorage.getItem('elevatorsPerPage')) || 15,
      //currentPage: 1,
      perPageOptions: [
        { value: 15, text: '15' },
        { value: 30, text: '30' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 0, text: 'All' },
      ],
      //selectedBrands: [],
      //selBrands: [],
      //selectedTypes: [],
      //selTypes: [],
      selColumns: [],
      colOrder: [],
      groupItems: { general: [], location: [], details: [], trips: [] },
      activePanel: null,
      stableElevatorBrands: [],
      stableElevatorTypes: [],
      generatingReport: false,
      //loggedIn: auth.loggedIn(),
      sortBy: localStorage.getItem('elevatorsSortBy') || 'status',
      sortDesc: localStorage.getItem('elevatorsSortDesc') === 'true',
      from: moment().subtract(1, 'months').startOf('month').format(),
      to: moment().subtract(1, 'months').endOf('month').format(),
      form: {
        from: '',
        to: '',
        elevators: [],
      },
      allColumns: [
        {
          key: 'status',
          label: '',
          sortable: true,
          thStyle: { width: '20px' },
          tdClass: 'status-cell',
        },
        {
          key: 'type',
          label: 'Brand',
          sortable: true,
          formatter: this.elevatorBrandFormatter,
        },
        {
          key: '_model',
          label: 'Type',
          sortable: true,
          formatter: (value, key, item) => this.elevatorTypeFormatter(item.type),
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          formatter: (value, key, item) => this.elevatorName(item),
        },
        {
          key: 'host',
          sortable: true,
          label: "Serial number",
        },
        {
          key: 'stopsUntilService',
          sortable: true,
          label: "Trips until maintenance",
        },
        {
          key: 'stopsToday',
          sortable: true,
          label: "Trips today",
        },
        {
          key: '_maintEstimate',
          sortable: true,
          label: 'Estimated maintenance date',
          formatter: (value, key, item) => item.estimatedDate || '',
        },
        {
          key: '_maintScheduled',
          sortable: true,
          label: 'Scheduled maintenance date',
          formatter: (value, key, item) => item.plannedDate || '',
        },
        {
          key: '_maintAvgPerDay',
          sortable: true,
          label: 'Trips per day',
          formatter: (value, key, item) => item.avgTripsPerDay != null ? Math.round(item.avgTripsPerDay) : 0,
        },
        {
          key: '_avgDropsPerDay',
          sortable: true,
          label: 'Disconnects per day',
          formatter: (value, key, item) => item.avgDropsPerDay != null ? Math.round(item.avgDropsPerDay) : 0,
        },
        {
          key: '_dropsToday',
          sortable: true,
          label: 'Disconnects today',
          formatter: (value, key, item) => item.dropsToday != null ? item.dropsToday : 0,
        },
        {
          key: 'addressLine1',
          sortable: true,
          label: 'Address',
          formatter: (value, key, item) => [item.addressLine1, item.addressLine2].filter(Boolean).join(', '),
        },
        {
          key: 'zipCode',
          sortable: true,
          label: 'Zip code',
        },
        {
          key: 'city',
          sortable: true,
          label: 'City',
        },
        {
          key: 'region',
          sortable: true,
          label: 'Region',
        },
        {
          key: 'country',
          sortable: true,
          label: 'Country',
        },
        {
          key: 'cid',
          sortable: true,
          label: 'Installation number',
        },
        {
          key: 'cdate',
          sortable: true,
          label: 'Commission date',
        },
        {
          key: 'eqdescr',
          sortable: true,
          label: 'Equipment description',
        },
        {
          key: 'description',
          sortable: true,
          label: 'Description',
        },
        {
          key: 'notes',
          sortable: true,
          label: 'Notes',
        },
      ]
    }
  },
  watch: {
    perPage(v) {
      if (v != 15) {
        localStorage.setItem('elevatorsPerPage', v);
      } else {
        localStorage.removeItem('elevatorsPerPage');
      }
      this.currentPage = 1;
    },
    elevatorBrands: {
      immediate: true,
      handler(v) { this.stableElevatorBrands = v; },
    },
    elevatorTypes: {
      immediate: true,
      handler(v) { this.stableElevatorTypes = v; },
    },
  },
  methods: {
    onBrandsAll() { persistBrands([]); persistModelTypes([]); },
    setFrom(v) { this.from = v ? moment(v).startOf('day').format() : this.from; },
    setTo(v) { this.to = v ? moment(v).endOf('day').format() : this.to; },
    onSortChanged({ sortBy, sortDesc }) {
      localStorage.setItem('elevatorsSortBy', sortBy);
      localStorage.setItem('elevatorsSortDesc', sortDesc);
    },
    invert() {
      this.selectedBrands = this.elevatorBrands.filter(x => !this.selBrands.includes(x));
      this.selectedTypes = this.elevatorTypes.filter(x => !this.selTypes.includes(x));
    },
    modalReportOpen(item, index, button) {
      this.$root.$emit('bv::show::modal', 'modalReport', button);
    },
    getReport(e) {
      e.preventDefault();
      this.generatingReport = true;
      this.form.from = this.from;
      this.form.to = this.to;
      this.form.elevators = this.eids;

      var t = this;
      api.getReport(this.form, response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'elevator_report_' + Date.now() + '.pdf';
        link.click();
        this.$root.$emit('bv::hide::modal', 'modalReport');
        t.generatingReport = false;
      });
    },
    sortCompare(a, b, key) {
      let aVal = a[key]
      let bVal = b[key]
      // Resolve virtual column keys to their underlying data fields
      if (key === '_maintEstimate') { aVal = a.estimatedDate; bVal = b.estimatedDate }
      else if (key === '_maintScheduled') { aVal = a.plannedDate; bVal = b.plannedDate }
      else if (key === '_maintAvgPerDay') { aVal = a.avgTripsPerDay; bVal = b.avgTripsPerDay }
      else if (key === '_avgDropsPerDay') { aVal = a.avgDropsPerDay; bVal = b.avgDropsPerDay }
      else if (key === '_dropsToday') { aVal = a.dropsToday; bVal = b.dropsToday }
      else if (key === '_model') { aVal = this.elevatorFormatter(a.type); bVal = this.elevatorFormatter(b.type) }
      // Push nulls/undefined to the end regardless of sort direction
      if (aVal == null && bVal == null) return 0
      if (aVal == null) return 1
      if (bVal == null) return -1
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return aVal > bVal ? -1 : (aVal < bVal ? 1 : 0)
      }
      return this.toString(aVal).localeCompare(this.toString(bVal), undefined, { numeric: true })
    },
    toString(v) {
      if (!v) {
        return ''
      }
      if (v instanceof Object) {
        return Object.keys(v)
          .map(k => this.toString(v[k]))
          .join(' ')
      }
      return String(v)
    },
    rowClickedHandler(record, index) {
      this.$router.push('/lifts/' + record.id);
    },
    resetColumns() {
      this.selColumns = [...DEFAULT_COLUMNS];
      this.saveCompressedColumns(this.selColumns);
      this.colOrder = COLUMN_GROUPS.flatMap(g => g.keys);
      this.saveColumnOrder(this.colOrder);
      this.initGroupItems();
    },
    initGroupItems() {
      for (const group of COLUMN_GROUPS) {
        this.groupItems[group.id] = group.keys
          .map(key => this.availableColumns.find(c => c.value === key))
          .filter(Boolean)
          .sort((a, b) => {
            const ai = this.colOrder.indexOf(a.value);
            const bi = this.colOrder.indexOf(b.value);
            if (ai === -1 && bi === -1) return 0;
            if (ai === -1) return 1;
            if (bi === -1) return -1;
            return ai - bi;
          });
      }
    },
    syncColOrder() {
      this.colOrder = COLUMN_GROUPS.flatMap(g => this.groupItems[g.id].map(c => c.value));
      this.saveColumnOrder(this.colOrder);
    },
    loadColumnOrder() {
      const stored = localStorage.getItem('elevatorColumnOrder');
      if (stored) {
        this.colOrder = JSON.parse(stored).filter(key => !key.startsWith('_header_'));
      } else {
        this.colOrder = COLUMN_GROUPS.flatMap(g => g.keys);
      }
      this.initGroupItems();
    },
    saveColumnOrder(order) {
      localStorage.setItem('elevatorColumnOrder', JSON.stringify(order));
    },
    loadCompressedColumns() {
      const stored = localStorage.getItem('elevatorColumns');
      if (stored) {
        this.selColumns = JSON.parse(stored);
      } else {
        this.selColumns = [...DEFAULT_COLUMNS];
      }
    },
    saveCompressedColumns(newColumns) {
      if (newColumns.length < this.availableColumns.length) {
        localStorage.setItem('elevatorColumns', JSON.stringify(newColumns));
      } else {
        localStorage.removeItem('elevatorColumns');
      }
    },
    loadCompressedBrands() { },
    loadCompressedTypes() { },
  },
  computed: {
    fromDate() { return this.from ? moment(this.from).format('YYYY-MM-DD') : '' },
    toDate() { return this.to ? moment(this.to).format('YYYY-MM-DD') : '' },
    fields() {
      const statusCol = this.allColumns.find(col => col.key === 'status');
      const selected = this.orderedAvailableColumns
        .filter(col => this.selColumns.includes(col.value))
        .map(col => this.allColumns.find(c => c.key === col.value));
      return [statusCol, ...selected];
    },
    availableColumns() {
      return this.allColumns
        .filter(col => col.key !== 'status')
        .map(col => ({ value: col.key, text: col.text || col.label || col.key }));
    },
    orderedAvailableColumns() {
      return COLUMN_GROUPS.flatMap(g => this.groupItems[g.id]);
    },
    columnGroupDefs() {
      return COLUMN_GROUPS;
    },
    selectedColumns: {
      get() {
        return this.selColumns;
      },
      set(newColumns) {
        this.selColumns = newColumns;
        this.saveCompressedColumns(newColumns);
      }
    },
    selBrands: {
      get() { return brandFilterStore.selBrands },
      set(v) { persistBrands(v.length < this.elevatorBrands.length ? v : []) },
    },
    selTypes: {
      get() { return brandFilterStore.selModelTypes },
      set(v) { persistModelTypes(v.length < this.elevatorTypes.length ? v : []) },
    },
    selectedBrands: {
      get() {
        return this.selBrands.length > 0 ? this.selBrands : this.stableElevatorBrands;
      },
      set(newBrands) {
        const effective = newBrands.length < this.stableElevatorBrands.length ? newBrands : [];
        if (effective.length === 0 && this.selBrands.length === 0) return;
        const oldBrands = this.selBrands.length > 0 ? this.selBrands : this.stableElevatorBrands;
        const addedBrands = newBrands.filter(b => !oldBrands.includes(b));
        this.selBrands = newBrands;
        this.currentPage = 1;
        // When a brand is re-added and types are explicitly filtered,
        // auto-select all types for the newly added brand
        if (addedBrands.length > 0 && this.selTypes.length > 0) {
          const newTypes = this.elevators
            .filter(e => addedBrands.includes(this.elevatorBrandFormatter(e.type)))
            .map(e => {
              const t = this.elevatorTypeFormatter(e.type);
              return t === '' ? 'Other' : t;
            })
            .filter((t, i, arr) => t && arr.indexOf(t) === i);
          this.selTypes = [...new Set([...this.selTypes, ...newTypes])];
        }
      }
    },
    selectedTypes: {
      get() {
        return this.selTypes.length > 0 ? this.selTypes : this.stableElevatorTypes;
      },
      set(newTypes) {
        const effective = newTypes.length < this.stableElevatorTypes.length ? newTypes : [];
        if (effective.length === 0 && this.selTypes.length === 0) return;
        this.selTypes = newTypes;
        this.currentPage = 1;
      }
    },
    showStatus: {
      get() {
        return this.$route.query.status || "";
      },
    },
    textFilter: {
      get() {
        return this.localTextFilter;
      },
      set(newFilter) {
        this.localTextFilter = newFilter;
        this.currentPage = 1;
        const state = Object.assign({}, window.history.state, { textFilter: newFilter });
        window.history.replaceState(state, '');
      }
    },
    currentPage: {
      get() {
        return parseInt(this.$route.query.page) || 1;
      },
      set(newPage) {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        if (newPage == 1) {
          delete queries.page;
          this.$router.replace({ query: queries });
        } else {
          queries.page = newPage;
          this.$router.replace({ query: queries });
        }
      }
    },
    elevatorBrands: function () {
      var eb = this.elevators.map(e => this.elevatorBrandFormatter(e.type));
      var distinct = [];
      for (var i = 0; i < eb.length; i++) {
        if (!(distinct.includes(eb[i]))) distinct.push(eb[i]);
      }
      distinct.sort();
      if (this._cachedElevatorBrands && this._cachedElevatorBrands.join('\0') === distinct.join('\0')) {
        return this._cachedElevatorBrands;
      }
      return (this._cachedElevatorBrands = distinct);
    },
    realElevatorTypes: function () {
      var et = this.elevators.map(e => e.type);
      var distinct = [];
      for (var i = 0; i < et.length; i++) {
        if (!(distinct.includes(et[i]))) {
          if (et[i] !== "" && et[i] !== undefined) {
            distinct.push(et[i])
          }
        }
      }
      return distinct.sort();
    },
    elevatorTypes: function () {
      var et = this.elevators.map(e => {
        var b = this.elevatorBrandFormatter(e.type);
        if (this.selectedBrands.includes(b)) {
          return this.elevatorTypeFormatter(e.type);
        }
      });
      var distinct = [];
      var other = false;
      for (var i = 0; i < et.length; i++) {
        if (!(distinct.includes(et[i]))) {
          if (et[i] !== "") {
            if (et[i] !== undefined) {
              distinct.push(et[i])
            }
          } else {
            other = true;
          }
        }
      }
      distinct.sort();
      if (other) distinct.push('Other');
      const key = distinct.join('\0');
      if (this._cachedElevatorTypes && this._cachedElevatorTypesKey === key) {
        return this._cachedElevatorTypes;
      }
      this._cachedElevatorTypesKey = key;
      return (this._cachedElevatorTypes = distinct);
    },
    filteredElevators: function () {
      return this.elevators
        .filter(e => this.showStatus == "" ? true : e.status == this.showStatus)
        .filter(e => this.selectedBrands.includes(this.elevatorBrandFormatter(e.type)))
        .filter(e => {
          var et = this.elevatorTypeFormatter(e.type);
          return this.selectedTypes.includes(et) || (this.selectedTypes.includes('Other') && (et == "" || et == undefined))
        })
        .filter(e => {
          if (!this.textFilter) return true;
          const q = this.textFilter.toLowerCase();
          const vals = [
            this.nameForStatus(e.status),
            this.elevatorName(e), e.host,
            e.stopsUntilService, e.stopsToday,
            e.estimatedDate, e.plannedDate,
            e.avgTripsPerDay != null ? Math.round(e.avgTripsPerDay) : '',
            e.addressLine1, e.addressLine2,
            e.zipCode, e.city, e.region, e.country,
            e.cid, e.cdate, e.eqdescr, e.description, e.notes,
          ];
          return vals.some(v => v != null && String(v).toLowerCase().includes(q));
        });
    },
    eids: function () {
      return this.filteredElevators.map(e => e.id);
    }
  },
  created() {
    this.loadColumnOrder();
    this.loadCompressedColumns();
  },
  beforeDestroy() {
  },
}
</script>

<style>
#elevators {
  contain: layout;
}

#elevators tr {
  cursor: pointer;
}

#elevators .status-cell {
  width: 20px;
  min-width: 20px;
  max-width: 20px;
  padding-right: 0;
}

#elevators .row-link {
  color: inherit;
  text-decoration: none;
}

.filter-panel {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.35s ease;
  will-change: max-height;
  transform: translateZ(0);
}

.filter-panel-open {
  max-height: 1000px;
}

.filter-panel-content {
  border: 1px solid #dee2e6;
  border-radius: 0 0.25rem 0.25rem 0.25rem;
  padding: 0.75rem 1rem 0.5rem;
}

.column-drag-item {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.drag-handle {
  cursor: grab;
  margin-right: 6px;
  color: #aaa;
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/Elevators.vue